// Примечания (4.10.4–4.10.6) и примеры (4.10.8): одно («Примечание – …») или несколько («Примечания» + «1 …»).
// Слова «Примечание –» / номера показывает CSS (по числу абзацев) - в тексте их не пишут.
import { Node, mergeAttributes } from '@tiptap/core';
import { idAttr, registryNodeView } from './util';

export const Note = Node.create({
  name: 'note',
  group: 'block',
  content: 'paragraph+',
  defining: true,
  addAttributes() { return { ...idAttr() }; },
  parseHTML() { return [{ tag: 'aside[data-type="note"]' }]; },
  renderHTML({ HTMLAttributes }) { return ['aside', mergeAttributes(HTMLAttributes, { 'data-type': 'note', class: 'sto-note' }), 0]; },
  addNodeView: registryNodeView('note'),
});

export const Example = Node.create({
  name: 'example',
  group: 'block',
  content: 'paragraph+',
  defining: true,
  addAttributes() { return { ...idAttr() }; },
  parseHTML() { return [{ tag: 'aside[data-type="example"]' }]; },
  renderHTML({ HTMLAttributes }) { return ['aside', mergeAttributes(HTMLAttributes, { 'data-type': 'example', class: 'sto-example' }), 0]; },
  addNodeView: registryNodeView('example'),
});

export const noteExtensions = () => [Note, Example];
